import { ApiInternalServerErrorResponse, ApiProperty } from '@nestjs/swagger';

export class RmEvaluationSamplesInfo{

    @ApiProperty()
    rmEvaluationSampleId?: number;

    @ApiProperty()
    rmEvaluationId?: number;

    @ApiProperty()
    time: Date;
    @ApiProperty()
    sampleNo: number;
    
    @ApiProperty()
    species: number;

    @ApiProperty()
    temperature: number;

    @ApiProperty()
    generalAppearance: string;

    @ApiProperty()
    generalOdour: string;

    @ApiProperty()
    freshness: string;

    @ApiProperty()
    dehydration: string;

    @ApiProperty()
    discolouration: string;

    @ApiProperty()
    deterioration: string;

    @ApiProperty()
    blackSpotOrTail: string;

    @ApiProperty()
    looseShells: string;

    @ApiProperty()
    brokenOrDamagedPcs: string;

    @ApiProperty()
    fungalGrowth: string;

    @ApiProperty()
    softSpecies: string;

    @ApiProperty()
    droopingHead: string;

    @ApiProperty()
    foreignMatter: string;

    @ApiProperty()
    sulphiteKit: string;

    @ApiProperty()
    pests: string;

    @ApiProperty()
    muddyOdour: string;

    @ApiProperty()
    cookedTexture: string;

    @ApiProperty()
    cookedFlavor: string;

    @ApiProperty()
    parasite: string;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    createdUser: string | null;


    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    updatedUser: string | null;


    @ApiProperty()
    versionFlag: number;
}